
/* styles */
require("!!vue-style-loader!css-loader!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-43880d36&scoped=true!sass-loader!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SettingsList.vue")

var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./SettingsList.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-43880d36!./../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./SettingsList.vue"),
  /* scopeId */
  "data-v-43880d36",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/SettingsList.vue
// module id = 49
// module chunks = 0